import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild,
  HostListener,
} from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";

// Global, unencapsulated stylesheet: injected via this side-effect import, not Angular's
// styleUrls/styleUrl, so it isn't scoped to this component.
import "./help-tooltip.component.scss";

@Component({
  selector: "app-help-tooltip",
  templateUrl: "./help-tooltip.component.html",
})
export class HelpTooltipComponent implements AfterViewInit, OnChanges {
  @Input() tooltipInfo: string;
  @Input() tooltipHeading: string;
  @Input() pointer: string;
  @Input() showHelpTooltip: boolean;
  //todo: extract tab type to a separate interface
  @Input() tabs: Array<{ key: number; content: string; type: string; class: string }>;
  @Input() tab: { key: number; content: string; type: string; class: string };
  @Output() onTooltipClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() toggleDeselected = new EventEmitter<void>();
  @Input() shouldRenderContent: boolean;

  @ViewChild("popupReference") popupReference: ElementRef;
  @ViewChild("tooltipOuter") tooltipOuter: ElementRef;
  @ViewChild("tooltipPointer") tooltipPointer: ElementRef;

  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
  ) {}

  ngAfterViewInit() {
    this.setPopupPositionWrapper();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.tooltipInfo ||
      changes.showHelpTooltip ||
      changes.popupReference ||
      changes.pointer
    ) {
      this.cdr.detectChanges();
      this.setPopupPositionWrapper();
    }
  }

  @HostListener("window:resize")
  onResize() {
    this.setPopupPositionWrapper();
  }

  setPopupPositionWrapper() {
    if (this.showHelpTooltip && this.popupReference) {
      this.setPopupPosition();
    }
  }

  closeHelpTooltip(e: MouseEvent) {
    const popupElement = this.popupReference.nativeElement as HTMLElement;
    this.renderer.removeStyle(popupElement, "height");
    this.showHelpTooltip = false;
    this.onTooltipClose.emit();
    this.toggleDeselected.emit();
  }

  private setPopupPosition() {
    const popupElement = this.popupReference.nativeElement as HTMLElement;
    const tooltipPointerElement = this.tooltipPointer.nativeElement as HTMLElement;

    let pointer = this.pointer;
    let buttonPosition: HTMLElement;
    if (this.deviceService.isMobile()) {
      pointer = "modal";
    }

    enum SvgOffset {
      Default = 0,
      Header = 5,
    }

    let svgOffset = SvgOffset.Default;
    //popup position
    if (this.tooltipInfo && this.popupReference) {
      if (pointer === "top") {
        const selectedTab = this.tabs.find((tab) => tab.class.includes("selected"));
        buttonPosition = document.getElementById(`scenario-${selectedTab.key + 1}-help-button`);
      } else if (pointer === "right") {
        this.renderer.addClass(tooltipPointerElement, "tw-hidden");
      } else if (pointer === "modal") {
        if (this.deviceService.isMobile()) {
          this.renderer.addClass(tooltipPointerElement, "tw-hidden");
          this.renderer.addClass(popupElement, "help-tooltip-mobile");

          // this is for absolute position to stick to the div
          // const popupPositionY =
          //   window.innerHeight -
          //   popupElement.getBoundingClientRect().top -
          //   popupElement.offsetHeight -
          //   75;
          // if (popupPositionY < 0) {
          //   this.renderer.setStyle(
          //     popupElement,
          //     "top",
          //     `${Math.max(popupElement.offsetTop + popupPositionY, 10)}px`
          //   );
          // }

          // this is for absolute position to stick to the bottom of the screen
          // const popupPositionY =
          //   window.innerHeight -
          //   popupElement.getBoundingClientRect().top -
          //   popupElement.offsetHeight;
          // if (popupPositionY < 0) {
          //   this.renderer.setStyle(
          //     popupElement,
          //     "top",
          //     `${popupElement.offsetTop+popupPositionY-5}px`
          //   );
          // }else{
          //   this.renderer.setStyle(
          //     popupElement,
          //     "top",
          //     `${popupElement.offsetTop+window.innerHeight-popupElement.getBoundingClientRect().top-popupElement.offsetHeight-5}px`
          //   );
          // }

          // and if this doesnt make the popup stay at the bottom on IOS, use the commented one above, description is in the first line
          // because the request keeps changing, please dont delete the commented code (in this method) for now
          this.renderer.addClass(popupElement, "!tw-fixed");

          const popupPositionX =
            window.innerWidth - popupElement.offsetLeft - popupElement.offsetWidth * 1.2;
          if (popupPositionX < 0) {
            this.renderer.setStyle(
              popupElement,
              "left",
              `${Math.max(popupElement.offsetLeft + popupPositionX, 0)}px`,
            );
          }
        } else {
          buttonPosition = document.getElementById("help-info-button");
          svgOffset = SvgOffset.Header;
          this.renderer.setStyle(
            popupElement,
            "top",
            `${buttonPosition.offsetTop + buttonPosition.offsetHeight + 16}px`,
          );
          pointer = "top";
        }
      } else if (pointer === "modal-header") {
        buttonPosition = document.getElementById("help-info-button-modal");
        this.renderer.setStyle(
          popupElement,
          "top",
          `${buttonPosition.offsetTop + buttonPosition.offsetHeight + 16}px`,
        );
        pointer = "top";
      }

      if (buttonPosition) {
        const relativePosition = 6; // screenWidth/tooltipWidth/pointerWidth
        const leftPosition =
          buttonPosition.offsetLeft -
          popupElement.offsetLeft -
          buttonPosition.offsetWidth / relativePosition;
        this.renderer.setStyle(tooltipPointerElement, "left", `${leftPosition + svgOffset}px`);
      }

      //actual pointer position
      if (pointer === "top") {
        // adjust the styling of the triangle to the bottom of the tooltip
        this.renderer.setStyle(
          tooltipPointerElement,
          "border-color",
          "transparent transparent var(--color-surface-elevated) transparent",
        );
        this.renderer.removeStyle(tooltipPointerElement, "top");
        this.renderer.setStyle(tooltipPointerElement, "bottom", "100%");
      } else if (pointer === "bottom") {
        this.renderer.removeChild(this, tooltipPointerElement);
        this.renderer.setStyle(popupElement, "left", "25vw");
      }
    }
  }
}
